import { ContentCopy, DeleteOutline, QuestionAnswer } from "@mui/icons-material";
import { Box, Chip, Typography } from "@mui/material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const accent = "#8b5cf6";

const renderQuestion = (question) => {
  if (!question) return "Pergunta não definida";

  return question.split(/\$\{([^}]+)\}/).map((part, index) => {
    if (index % 2 === 0) {
      return (
        <span key={index}>
          {part}
        </span>
      );
    }

    return (
      <Chip
        key={index}
        label={part}
        size="small"
        sx={{
          height: 20,
          mx: 0.25,
          bgcolor: "rgba(139, 92, 246, 0.10)",
          color: accent,
          border: "1px solid rgba(139, 92, 246, 0.20)",
          "& .MuiChip-label": { px: 0.75, fontSize: 11 }
        }}
      />
    );
  });
};

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <Box
      sx={{
        width: 220,
        bgcolor: "#ffffff",
        borderRadius: "8px",
        border: "1px solid #e5e7eb",
        boxShadow: "0 8px 18px rgba(15, 23, 42, 0.10)",
        overflow: "hidden",
        position: "relative"
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: accent,
          width: 8,
          height: 8,
          left: -4,
          top: "50%"
        }}
        isConnectable={isConnectable}
      />

      <Box
        sx={{
          height: 34,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 1.25,
          background: "linear-gradient(180deg, rgba(139,92,246,0.10), rgba(139,92,246,0.02))",
          borderBottom: "1px solid rgba(139, 92, 246, 0.12)"
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 21,
              height: 21,
              borderRadius: "5px",
              bgcolor: "rgba(139, 92, 246, 0.14)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <QuestionAnswer sx={{ width: 15, height: 15, color: accent }} />
          </Box>
          <Typography sx={{ color: accent, fontSize: 13, fontWeight: 600 }}>
            Pergunta
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <ContentCopy
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("duplicate");
            }}
            sx={{ width: 15, height: 15, color: "#6b7280", cursor: "pointer" }}
          />
          <DeleteOutline
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("delete");
            }}
            sx={{ width: 16, height: 16, color: "#6b7280", cursor: "pointer" }}
          />
        </Box>
      </Box>

      <Box sx={{ p: 1.5, minHeight: 86 }}>
        <Typography
          component="div"
          sx={{
            color: data.question ? "#374151" : "#9ca3af",
            fontSize: 12,
            lineHeight: 1.45,
            minHeight: 22,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            fontStyle: data.question ? "normal" : "italic"
          }}
        >
          {renderQuestion(data.question)}
        </Typography>

        <Box
          sx={{
            mt: 1.25,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1
          }}
        >
          <Typography sx={{ color: accent, fontSize: 12, fontWeight: 600 }}>
            {data.variableName ? `→ ${data.variableName}` : "→ variável"}
          </Typography>
          <Typography sx={{ color: "#6b7280", fontSize: 11 }}>
            Resposta
          </Typography>
        </Box>
      </Box>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: accent,
          width: 8,
          height: 8,
          right: -4,
          top: "72%"
        }}
        isConnectable={isConnectable}
      />
    </Box>
  );
});
